<template>
<!--分学银行-->
  <div class="content">
    <headers></headers>
    <div class="nav">
      <div class="auto">行业证书  >  操作指南  >  证书信息登记   > 缴费支付 </div>
    </div>
    <div class="auto padding250">
       <p class="title">缴费支付</p>
      <div class="container ">
        <p class="txt-center" style="display: none;"><img src="../../assets/step3.png" alt=""></p>
           <p class="txt-center" style="display: none;"><img src="../../assets/step5.png" alt=""></p>
            <p class="txt-center"><img src="../../assets/step31.png" alt=""></p>
        <!-- 报名成功提示 -->
        <div style="display: none;">
          <p class="title">报名成功提示</p>
          <div class="tip"><p>学员您好！恭喜您报名成功，请在24小时内完成缴费。</p></div>
          <div class="keepThis"><router-link  to="/" class="keepBtn">确认支付</router-link></div>
        </div>
        <!-- 报名失败提示 -->
        <div style="display: none;">
          <p class="title">报名失败提示</p>
          <div class="tip"><p>学员您好！您所填写的报名资料“教育经历”不符合报名条件要求。</p></div>
          <div class="keepThis"><router-link  to="/" class="keepBtn error">重新填写</router-link></div>
        </div>
        <!-- 确认支付 -->
        <div class="clearfix">
           <ul class="left pull-left">
             <li class="title">报考科目：项目经理证书</li>
             <li class="money">报考费用：<span>￥198.00</span></li>
             <li class="date">考试时间：2020-02-20  09:00</li>
           </ul>
           <div class="right pull-left">
             <p class="title">考试说明：准备报名参加项目经理职业资格</p>
             <p class="tip">考试的学员选择“考试报名”，学员填写参加考试必要的基础资料包括：个人基本资料、学历信息、工作经历信息、培训机构信息、培训资格证信息、账号、密码，信息填写完整后需要缴费，缴费完成后提交完成考试报名，考生牢记账号（账号可以是身份证号码或手机号）密码，凭账号密码参加考试（单点登录）；考生填写信息过程中系统将自动判断考生填写的信息与报考条件是否匹配。 行业证书报考科目可以后台自定义设置：如：“项目经理、设施设备和他........”；</p>
           </div>
        </div>
           <ul class="left ">
             <li class="title margin20">需支付金额</li>
             <li class="money margin0">应付金额：<span>￥198.00</span></li>
           </ul>
      </div>
      <div class="container padding20">
        <p class="titles">支付方式</p>
		<ul class="way">
		  <li :class="{active:0===nowIndex}"  @click="toggle(0)">
		    <img src="../../assets/radio.png" alt="">
		    <label for=""><img src="../../assets/buy1.png" alt="" width="20">支付宝支付</label>
		  </li>
		  <li @click="toggle(1)" :class="{active:1===nowIndex}">
		    <img src="../../assets/radio1.png" alt="">
		    <label for=""><img src="../../assets/buy2.png" alt="" width="21">微信支付</label>
		  </li>

		</ul>
      <router-link to="/">立即支付</router-link>
      </div>
    </div>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .way{
    padding-top: 30px;
    margin-bottom: 15px;
    li{
      display: inline-block;
      margin: 0 40px 30px 0;
      >img{
        vertical-align: middle;
        margin-right: 20px;
      }
    }

    li label{
      width: 154px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: #333;
      border:1px solid #d9d9d9;
      text-align: center;
      display: inline-block;

      cursor: pointer;
      img{
        vertical-align: middle;
        margin-right: 10px;
      }
    }
    li:last-child{
      margin-bottom: 6px;
    }
    li.active label{
      border-color: #00aaf0;
    }
  }
  .nav{
    color: #fff;
    background-color: #2F261E;
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .content{
    background-color: #f5f5f5;
    text-align: left;
    .title{
      font-size: 26px;
      color: #000;
      margin-top: 30px;
    }

    .container{
      background-color: #fff;
      padding: 50px 30px 30px;
      margin-top: 10px;

      .title{
        font-size: 18px;
        padding-left: 110px;
        margin-top: 80px;
      }

      .tip{
          font-size: 14px;
          color: #999;
         padding-left: 110px;
          margin: 20px 0 40px;
          p{
             border-bottom: 1px solid #DBDBDB;
             padding-bottom: 100px;
          }

      }
      .clearfix{
        border-bottom: 1px solid #dbdbdb;
        .left{
          width: 385px;
        }
        .right{
           width: 755px;
           .tip{
             padding-left: 0;
             line-height: 26px;
           }
        }
      }
      .left ,.right{
        .title{
          color: #333;
          padding-left: 0px;
          &.margin20{
            margin-top: 30px;
          }
        }
        .money{
          color: #666;
          font-size: 16px;
          margin: 10px 0 50px;
          &.margin0{
            margin-bottom: 0;
          }
          span{
            color: #FF0000;
            font-size: 22px;
          }
        }
        .date{
          color: #999;
          font-size: 16px;
        }
      }
      .keepThis{
        padding-left: 110px;
      }
      a{
        color: #fff;
        display: inline-block;
        width: 220px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-radius: 5px;
        font-size: 16px;
        background-color: #957960;
      }
      .error{
        background-color: #083C68;
      }
    }
    .padding20{
      padding-top: 20px;
      margin-top: 20px;
      .titles{
         font-size: 18px;
         color: #333;
         border-bottom: 1px solid #dbdbdb;
        padding-bottom: 10px;
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'

    export default {
        name: 'fenxue',
        props: {},
        data() {
            return {
             nowIndex:0
            };
        },
        methods: {
          toggle(index){
            this.nowIndex = index;
          },
        },
        created() {

        },
        components: {
          headers,
          footers

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/changeScore/step3.vue